import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
} from '@mui/material'
import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}


const Status = ({status, setStatus, dataList, hasAll = true}) => {
    const isAll = hasAll && status?.includes(-1)
    const [checked, setChecked] = useState(isAll)
    const [disabled, setDisabled] = useState(isAll)

    const refreshClicked = useSelector((state) => state.buttonSlice.refreshClicked)

    useEffect(() => {
        if (refreshClicked) {
            setChecked(isAll)
            setDisabled(isAll)
        }
    }, [refreshClicked])

    const handleCheckChange = (event) => {
        const isChecked = event.target.checked
        setChecked(isChecked)
        setDisabled(isChecked)
        if (isChecked) {
            setStatus([-1])
        } else {
            setStatus([])
        }
    }

    const handleChange = (event) => {
        const selectedStatus = event.target.value
        setStatus(selectedStatus)
        setChecked(selectedStatus.includes(-1))
    }

    return (
        <>
            {hasAll ? (
                <Grid container spacing={1}>
                    <Grid item xs={9}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Status</InputLabel>
                            <Select
                                multiple
                                disabled={disabled}
                                value={status || []}
                                onChange={handleChange}
                                input={<OutlinedInput label="Status"/>}
                                MenuProps={MenuProps}
                                sx={disabled && {
                                    backgroundColor: 'hsl(0, 0%, 95%)',
                                }}
                                renderValue={(selected) => {
                                    if (selected.includes(-1)) {
                                        return 'All'
                                    }
                                    return selected.map((x) => dataList.find((y) => y.statusId === x)?.statusName).join(', ')
                                }}
                            >
                                {dataList.map((item) => (
                                    <MenuItem key={item.statusId} value={item.statusId}>
                                        <Checkbox checked={status?.includes(item.statusId)}/>
                                        <ListItemText primary={item.statusName}/>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox checked={checked} onChange={handleCheckChange}/>}
                                              label="All"/>
                        </FormGroup>
                    </Grid>
                </Grid>
            ) : (
                <div>salam</div>
            )}
        </>
    )
}

export default Status